import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

let cachedLogoUrl = null;
let cacheTimestamp = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export const useOrgLogo = () => {
  const [logoUrl, setLogoUrl] = useState(cachedLogoUrl);
  const [loading, setLoading] = useState(!cachedLogoUrl);

  useEffect(() => {
    const now = Date.now();
    if (cachedLogoUrl && (now - cacheTimestamp) < CACHE_TTL) {
      setLogoUrl(cachedLogoUrl);
      setLoading(false);
      return;
    }
    fetchLogo();
  }, []);

  const fetchLogo = async () => {
    try {
      const { data } = await supabase
        ?.from('organizations')
        ?.select('logo_url, name, primary_color')
        ?.limit(1)
        ?.single();
      const url = data?.logo_url || null;
      cachedLogoUrl = url;
      cacheTimestamp = Date.now();
      setLogoUrl(url);
    } catch {
      setLogoUrl(null);
    } finally {
      setLoading(false);
    }
  };

  return { logoUrl, loading };
};

export default useOrgLogo;